import { styled } from "styled-components";

export const ScreenHeader = styled.div`
  display: flex;
  align-items: center;
  padding-bottom: ${({ theme }) => theme.spacing[4]};

  @media (max-width: 768px) {
    flex-direction: column-reverse;
    align-items: flex-start;
    padding-bottom: ${({ theme }) => theme.spacing[3]};
  }
`;

export const HeaderTiles = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: ${({ theme }) => theme.spacing[4]};

  @media (max-width: 1600px) {
    grid-template-columns: 1fr;
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: ${({ theme }) => theme.spacing[3]};
  }
`;

export const HeaderDetailTile = styled.div`
  grid-column: span 2;
  padding: ${({ theme }) => theme.spacing[4]};
  background-color: ${({ theme }) => theme.colors.background.layers[700]};

  @media (max-width: 1600px) {
    grid-column: span 1;
  }

  // TODO: Temp solution
  & > div {
    height: 100%;
  }
`;

export const TileWrapper = styled.div`
  display: grid;
  grid-template-rows: 1fr 1fr;
  gap: ${({ theme }) => theme.spacing[4]};

  @media (max-width: 1600px) {
    grid-template-columns: 1fr 1fr;
    grid-template-rows: none;
  }

  @media (max-width: 768px) {
    grid-template-rows: 1fr 1fr;
    grid-template-columns: none;
    gap: ${({ theme }) => theme.spacing[3]};
  }
`;

export const DeviceTwinHierarchyWrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.background.layers[700]};
  border: 1px solid ${({ theme }) => theme.colors.border.weak};
`;

export const Tile = styled.div`
  background-color: ${({ theme }) => theme.colors.background.layers[700]};
  border: 1px solid ${({ theme }) => theme.colors.border.weak};
`;

export const ListTile = styled.div`
  position: relative;
  margin-top: ${({ theme }) => theme.spacing[4]};
  background-color: ${({ theme }) => theme.colors.background.layers[700]};
  padding: ${({ theme }) => theme.spacing[4]};

  @media (max-width: 768px) {
    margin-top: ${({ theme }) => theme.spacing[3]};
  }
`;

export const NextButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${({ theme }) => theme.spacing[5]};
  min-width: ${({ theme }) => theme.spacing[5]};
  height: ${({ theme }) => theme.spacing[5]};
  border-radius: ${({ theme }) => theme.spacing[1]};
  transition: background-color 0.2s ease;
  background-color: ${({ theme }) => theme.colors.background.layers[600]};
`;

export const IconCircle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${({ theme }) => theme.spacing[5]};
  min-width: ${({ theme }) => theme.spacing[5]};
  height: ${({ theme }) => theme.spacing[5]};
  border-radius: 50%;
  background-color: ${({ theme }) => theme.colors.background.grundfos.primary};
`;

export const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing[4]};
`;

export const BackButtonWrapper = styled.div`
  @media (max-width: 768px) {
    display: none;
  }
`;

export const CreateButtonWrapper = styled.div`
  position: absolute;
  top: ${({ theme }) => theme.spacing[5]};
  right: ${({ theme }) => theme.spacing[4]};

  @media (max-width: 768px) {
    margin-bottom: ${({ theme }) => theme.spacing[3]};
    align-self: flex-end;
  }
`;

export const EmptyTile = styled.div`
  padding: ${({ theme }) => theme.spacing[5]};
  background-color: ${({ theme }) => theme.colors.background.layers[700]};
  border: 1px solid ${({ theme }) => theme.colors.border.weak};
`;

export const SpinnerWrapper = styled.div`
  display: flex;
  min-height: 200px;
  width: 100%;
  justify-content: center;
  align-items: center;
`;

export const EdgeTileContainer = styled.div`
  margin-top: ${({ theme }) => theme.spacing[4]};
`;
